import { environment } from '../environment'

export const SESSION_DURATION_HOURS = /local.*|development|staging/.test(environment.environment ?? '') ? 24 * 7 : 12
export const SESSION_DURATION_MINUTES = SESSION_DURATION_HOURS * 60
